/**
 * Route for `per-publisher-fraud-rule-sets`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PerPublisherFraudRuleSetsPage } from "../features/per-publisher-fraud-rule-sets/PerPublisherFraudRuleSetsPage";

export const perPublisherFraudRuleSetsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/per-publisher-fraud-rule-sets",
	component: PerPublisherFraudRuleSetsPage,
});

export default perPublisherFraudRuleSetsRoute;
